import { useMarketMetadata } from '@//providers/MarketSettingsProvider';

const useMarketTimeZone = (): string => {
  const marketMetadata = useMarketMetadata();
  return marketMetadata.timeZone;
};

export default useMarketTimeZone;
